import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import { nmsMenus } from "globals/configuration/nms";
import DiscoveredIpAction from "application/components/DiscoveredIPAction";
import CTLBooleanCell from "application/components/CTLBooleanCell";

const Attributes = {
  formSize: "md",
  columns: 3,
  dynamicTitle: true,
  title: "Add-In-Scada-Asset",
  multiUpdateTitle:"Multiple-False-Update",
  
  enableMultipleUpdate: true,
  enableAdvanceSearch: true,
  enableNoDefaultComparisonButton: true,
  enableGroupHeading: false,
  verticalTabs: false,
  enableRefresh: true,
  tabSize: 4,
  modes: nmsMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "/discoverIp/list",
  update: "/discoverIp/update",
  register: "/discoverIp/create",
};

const getColumns = (onDelete, onEdit,onHandleUpdateList) => {
  return [
    {
      Header: "IP Address",
      accessor: "ipAddress",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "ip",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Category",
      accessor: "category",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      controlType: "ip",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Discover Time",
      accessor: "discoveryTime",
      displayInList: true,
      allowInForm: true,
      dateTime:true,
      allowFilter: true,
      dataType: "date",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Last Seen",
      accessor: "lastSeen",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime:true,
      dataType: "date",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Location",
      accessor: "location",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "inUse",
      accessor: "inUse",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "boolean",
      width: 6,
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => <DiscoveredIpAction row={row} onHandleUpdateList={onHandleUpdateList}/>,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
